var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "26px",
    height: "26px",
    className: "uil-default",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    fill: "none",
    className: "bk"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(0 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(30 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.08333333333333333s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(60 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.16666666666666666s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(90 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.25s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(120 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.3333333333333333s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(150 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.4166666666666667s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(180 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.5s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(210 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.5833333333333334s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(240 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.6666666666666666s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(270 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.75s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(300 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.8333333333333334s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 20,
    x: 46.5,
    y: 40,
    fill: "#ffffff",
    rx: 5,
    ry: 5,
    transform: "rotate(330 50 50) translate(0 -30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.9166666666666666s",
    dur: "1s",
    from: 1,
    repeatCount: "indefinite",
    to: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.93b9073e3877da9760a5a7605642f8e2.svg";
export { ForwardRef as ReactComponent };